import { render, staticRenderFns } from "./PeaAggregatedResultsTable.vue?vue&type=template&id=a377ed14&scoped=true&"
import script from "./PeaAggregatedResultsTable.vue?vue&type=script&lang=ts&"
export * from "./PeaAggregatedResultsTable.vue?vue&type=script&lang=ts&"
import style0 from "./PeaAggregatedResultsTable.vue?vue&type=style&index=0&id=a377ed14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a377ed14",
  null
  
)

export default component.exports